var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container-1"},[_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }